import { action } from 'typesafe-actions';
import {
  ICheckoutResponse,
  ICustomerIdParams,
  IDataOrderSimulate,
  IOrderSimulateState,
  ISalesParams,
  Types
} from './types';

// GERAR SIMULAÇÃO DE ORDEM DE VENDA
export const orderSimulateRequest = (params: IDataOrderSimulate) =>
  action(Types.REQUEST_ORDER_SIMULATE, { params });

export const orderSimulateRequestSuccess = (data: ICheckoutResponse) =>
  action(Types.REQUEST_ORDER_SIMULATE_SUCCESS, { data });

export const orderSimulateRequestFailure = (params: IDataOrderSimulate) =>
  action(Types.REQUEST_ORDER_SIMULATE_FAILURE, { params });

export const cleanOrderSimulate = () => action(Types.CLEAN_ORDER_SIMULATE);

// FINALIZAR PEDIDO
export const confirmSale = (params: ISalesParams) =>
  action(Types.REQUEST_FINALIZE_SALE, { params });

export const confirmedSale = (ordersSent: string[]) =>
  action(Types.FINALIZE_SALE_SUCCESS, { ordersSent });

export const confirmSaleFailure = (errorMessage: string) =>
  action(Types.FINALIZE_SALE_FAILURE, { errorMessage });

export const resetSaleFailureConfirmation = () =>
  action(Types.RESET_SALE_FAILURE_CONFIRMATION);
// ATUALIZAR DADOS DA ORDEM DE VENDA
export const updateCustomerOrderId = (customerIdParams: ICustomerIdParams) =>
  action(Types.UPDATE_CUSTOMER_ORDER_ID, { customerIdParams });

export const updateCustomerPurchoseId = (customerId: string) =>
  action(Types.UPDATE_CUSTOMER_PURCHASE_ID, { customerId });
// LocalStorage
export const updateCheckoutLocalStorage = (params: IOrderSimulateState) =>
  action(Types.UPDATE_CHECKOUT_STATE_LOCAL_STORAGE, { params });

export const updateCheckout = (params: IOrderSimulateState) =>
  action(Types.UPDATE_CHECKOUT_STATE, { params });
